import React from "react";
// import { Link } from "react-router-dom";
import test from "../../assets/test.png";
import { motion } from "framer-motion";

const Lesson = ({ les, handleLesson}) => {
  // console.log(les)
  return (
    // <Link to="/" className="link-lesson">
    <motion.div
      className="card mb-3 lesson-custom-card"
      
      onClick={() => handleLesson(les._id)}
    >
      <div className="row g-0 lesson-custom">
        <div className="col-md-4 lesson-custom-left">
          <img
            src={test}
            className="img-fluid rounded img-fluid-custom"
            alt="test"
          />
        </div>
        <div className="col-md-8 lesson-custom-right">
          <div className="card-body">
            <h5 className="card-title">{les.name}</h5>
            {/* <p className="card-text">30:20</p> */}
          </div>
        </div>
      </div>
    </motion.div>
    // </Link>
  );
};

export default Lesson;
